import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { useSelector } from "react-redux";

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: theme.palette.common.white,
      color: '#1e293b',
      boxShadow: '0 12px 30px rgba(15, 23, 42, 0.18)',
      border: '1px solid #dbe4f0',
      borderRadius: 10,
      fontSize: 13,
      minWidth: 280,
      maxWidth: 380,
      padding: 10,
    },
    [`& .MuiTooltip-arrow`]: { color: theme.palette.common.white },
  }));
  
  const getStatusColor = (status) => {
    if (status === 2) return 'green';
    if (status === 1) return 'red';
    return '#c96f1a';
  };

  const ApproverTooltip = ({ approvers, children }) => {
    const loginData = useSelector((state) => state.loginData.value);
    
    return (
        <LightTooltip
            title={
                <div>
                    <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                        <thead>
                            <tr style={{ background: '#f1f5f9' }}>
                                <th style={{ padding: '8px 10px', textAlign: 'left', color: '#475569', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Approver</th>
                                <th style={{ padding: '8px 10px', textAlign: 'left', color: '#475569', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Comments</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(approvers) && approvers.length > 0 ? approvers.map((approver, index) => (
                                <tr key={index} style={{ borderBottom: index < approvers.length - 1 ? '1px solid #e2e8f0' : 'none' }}>
                                    <td style={{ padding: '9px 10px', fontWeight: 600, whiteSpace: 'nowrap' }}>{approver.account_id__org_id__first_name || '-'}</td>
                                    <td style={{ padding: '9px 10px', color: '#475569', lineHeight: 1.45 }}>
                                        {approver.timeline_comment || 'No comment'}
                                    </td>
                                </tr>
                            )) : <tr><td colSpan="2" style={{ padding: '10px', textAlign: 'center', color: '#64748b' }}>No comments available</td></tr>}
                        </tbody>
                    </table>
                </div>
            }
            arrow
            placement="top"
        >
            {children}
        </LightTooltip>
    );
};
  
  export default ApproverTooltip;
